import React from "react";

import getShopSitemapLocations from "api/requests/consumerApi/getShopSitemapLocations";
import { createGetServerSideProps } from "utils/createGetServerSideProps";

import Breadcrumb from "components/Breadcrumb";
import Breadcrumbs from "components/Breadcrumbs";
import LocationsGrid, { Locations } from "components/LocationsGrid";
import MetaTags from "components/MetaTags";

interface ShopLocationsPageProps {
  locations: Locations;
}

const ShopLocationsPage: React.FC<ShopLocationsPageProps> = ({ locations }) => (
  <>
    <MetaTags
      title="Shop the best cannabis products in a city near you"
      description="Find your favorite weed, CBD, THCa products in a city near you"
    />

    <div className="container mt-xl mb-xxl">
      <h1 className="mb-lg">Shop cannabis products in a city near you</h1>

      <LocationsGrid
        locations={locations}
        className="mb-section"
        useAnchorTags={true}
      />

      <Breadcrumbs>
        <Breadcrumb href="/shop">Shop</Breadcrumb>
        <Breadcrumb currentLocation href="/shop/locations">
          All shop locations
        </Breadcrumb>
      </Breadcrumbs>
    </div>
  </>
);

export const getServerSideProps =
  createGetServerSideProps<ShopLocationsPageProps>(async () => {
    const { locations } = await getShopSitemapLocations();
    return {
      props: {
        locations,
      },
    };
  });

export default ShopLocationsPage;
